import type { DetailedService } from '@/mocks/leistungen';

interface Props {
  service: DetailedService;
  index: number;
}

export default function ServiceDetailCard({ service, index }: Props) {
  const isEven = index % 2 === 0;

  return (
    <article className={`flex flex-col lg:flex-row ${isEven ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-8 lg:gap-12 items-center py-12 md:py-16 border-b border-blush last:border-b-0`}>
      {/* Image */}
      <div className="w-full lg:w-[45%] flex-shrink-0">
        <div className="relative rounded-2xl overflow-hidden">
          <img
            src={`https://public.readdy.ai/ai/img_res/15302d662d124d55de5097ff8d156d8c.jpg${service.imageSeq}&orientation=landscape`}
            alt={`${service.name} – kosmetische Zahnaufhellung Köln`}
            className="w-full h-56 md:h-72 object-cover object-center"
          />
          {/* Price badge */}
          <div className="absolute top-4 left-4">
            <div className="bg-charcoal text-white rounded-full px-4 py-1.5">
              <span className="font-serif text-lg font-medium">{service.price}</span>
            </div>
          </div>
          {/* Tag */}
          <div className="absolute top-4 right-4">
            <span className="bg-rose text-white font-sans text-xs font-semibold tracking-wide uppercase px-3 py-1.5 rounded-full">
              {service.tag}
            </span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="w-full lg:w-[55%]">
        {/* Duration */}
        <div className="flex items-center gap-2 mb-3">
          <span className="w-5 h-5 flex items-center justify-center">
            <i className="ri-time-line text-rose text-sm" />
          </span>
          <span className="font-sans text-sm text-charcoal/60">{service.duration}</span>
        </div>

        <h3 className="font-serif text-3xl md:text-4xl font-medium text-charcoal mb-4">
          {service.name}
        </h3>
        <p className="font-sans text-base text-charcoal/65 leading-relaxed mb-6">
          {service.description}
        </p>

        {/* Includes */}
        <div className="mb-8">
          <p className="font-sans text-xs uppercase tracking-widest font-semibold text-charcoal/50 mb-3">
            Enthält:
          </p>
          <ul className="flex flex-col gap-2.5">
            {service.includes.map((item, i) => (
              <li key={i} className="flex items-center gap-3">
                <span className="w-5 h-5 flex items-center justify-center bg-rose/15 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-rose text-xs" />
                </span>
                <span className="font-sans text-sm text-charcoal/70">{item}</span>
              </li>
            ))}
          </ul>
        </div>

        {/* CTA */}
        <a
          href="https://simplybook.me"
          target="_blank"
          rel="nofollow noreferrer"
          className="inline-flex items-center gap-2 bg-rose hover:bg-rose-dark text-white font-sans font-medium text-sm px-7 py-3.5 rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-calendar-line text-sm" />
          </span>
          Jetzt buchen — {service.price}
        </a>
      </div>
    </article>
  );
}
